/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Provision_Waterfall_HintInputs */

const cs_deal_provision_waterfall_hint = /** @type {(inputs: Deal_Provision_Waterfall_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provize kanceláře je to, co RK vydělá — ne cena nemovitosti. Podíly rozdělují tuto částku mezi makléře.`)
};

const en_deal_provision_waterfall_hint = /** @type {(inputs: Deal_Provision_Waterfall_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agency take is what the office earns — not the listing price. Splits divide that take among agents.`)
};

/**
* | output |
* | --- |
* | "Agency take is what the office earns — not the listing price. Splits divide that take among agents." |
*
* @param {Deal_Provision_Waterfall_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_provision_waterfall_hint = /** @type {((inputs?: Deal_Provision_Waterfall_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Provision_Waterfall_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_provision_waterfall_hint(inputs)
	return cs_deal_provision_waterfall_hint(inputs)
});